import React from "react";
import { Instagram, Send, Phone } from "lucide-react";
import PageLayout from "../components/PageLayout";
import { BRAND, BRAND_BG, BRAND_BORDER, cardBase } from "../theme/colors";

interface Teacher {
  id: string;
  name: string;
  type: string;
  studentsCount: string;
  initial: string;
  instagram?: { username: string; url: string };
  telegram?: { username: string; url: string };
  phone?: string;
}

const TEACHERS: Teacher[] = [
  {
    id: "azimjon",
    name: "Azimjon Abdumannopov",
    type: "Amaliy ustoz",
    studentsCount: "1000+ o'quvchi",
    initial: "A",
    instagram: {
      username: "avtoinstructor_uzb",
      url: "https://instagram.com/avtoinstructor_uzb",
    },
    telegram: { username: "@Azimjon727", url: "https://t.me/Azimjon727" },
    phone: "+998 94 686 99 33",
  },
];

const TeachersPage: React.FC = () => {
  return (
    <PageLayout title="Ustozlar" subtitle="Tajribali murabbiylar">
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {TEACHERS.map((teacher) => (
          <div
            key={teacher.id}
            style={{
              ...cardBase,
              padding: 16,
            }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 14,
                paddingBottom: 14,
                borderBottom: "1px solid var(--border)",
              }}>
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: "50%",
                  background: BRAND_BG,
                  border: `1px solid ${BRAND_BORDER}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: BRAND,
                  fontWeight: 800,
                  fontSize: 22,
                  flexShrink: 0,
                }}>
                {teacher.initial}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ color: "#fff", fontWeight: 800, fontSize: 15 }}>
                  {teacher.name}
                </p>
                <p
                  style={{
                    color: "var(--muted)",
                    fontSize: 12,
                    marginTop: 3,
                  }}>
                  {teacher.type} · {teacher.studentsCount}
                </p>
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {teacher.instagram && (
                <a
                  href={teacher.instagram.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "10px 12px",
                    borderRadius: 10,
                    background: "rgba(255,255,255,.03)",
                    border: "1px solid var(--border)",
                    textDecoration: "none",
                    color: "#fff",
                    fontSize: 13,
                    fontWeight: 600,
                  }}>
                  <Instagram size={16} style={{ color: BRAND }} />
                  {teacher.instagram.username}
                </a>
              )}
              {teacher.telegram && (
                <a
                  href={teacher.telegram.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "10px 12px",
                    borderRadius: 10,
                    background: "rgba(255,255,255,.03)",
                    border: "1px solid var(--border)",
                    textDecoration: "none",
                    color: "#fff",
                    fontSize: 13,
                    fontWeight: 600,
                  }}>
                  <Send size={16} style={{ color: BRAND }} />
                  {teacher.telegram.username}
                </a>
              )}
              {teacher.phone && (
                <a
                  href={`tel:${teacher.phone.replace(/\s/g, "")}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "10px 12px",
                    borderRadius: 10,
                    background: "rgba(255,255,255,.03)",
                    border: "1px solid var(--border)",
                    textDecoration: "none",
                    color: "#fff",
                    fontSize: 13,
                    fontWeight: 600,
                  }}>
                  <Phone size={16} style={{ color: BRAND }} />
                  {teacher.phone}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </PageLayout>
  );
};

export default TeachersPage;
